import React, { useContext, useEffect } from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import { LogoProps } from 'types/LogoProps';
import SimpleInput from 'components/SimpleInput';
import InputImgBigger from 'components/InputImgBigger';
import { ImgSavedProps } from 'types/ImgSavedProps';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { addLogoReq, editLogoReq } from './reqs';

interface FormLogoProps {
	isOpenForm: boolean;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	logoToEdit: LogoProps | null;
	setLogoToEdit: React.Dispatch<React.SetStateAction<LogoProps | null>>;
	setListLogos: React.Dispatch<React.SetStateAction<LogoProps[]>>;
	listLogos: LogoProps[];
}

const initialStateForm: LogoProps = {
	id: '',
	name: '',
	urlLogo: '',
	position: 0
};

export default function FormLogo({
	isOpenForm,
	setIsOpenForm,
	logoToEdit,
	setListLogos,
	listLogos,
	setLogoToEdit
}: FormLogoProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [dataForm, setDataForm] = React.useState<LogoProps>(
		logoToEdit
			? logoToEdit
			: {
					...initialStateForm,
					position: listLogos[listLogos.length - 1]?.position + 1 || 1
				}
	);

	function resetStatesComp() {
		setIsOpenForm(false);
		setDataForm(initialStateForm);
		setLogoToEdit(null);
	}

	function verifyIfCanSave() {
		if (dataForm.name === '') {
			handleNotify('Preenha o nome', 'error');
			return false;
		}

		if (dataForm.urlLogo === '') {
			handleNotify('Insira a logo', 'error');
			return false;
		}

		return true;
	}

	async function saveLogo() {
		const canSave = verifyIfCanSave();

		if (!canSave) {
			handleNotify('Algum erro aconteceu', 'error');
			return;
		}

		const { isSuccess, logoSaved } = await addLogoReq(
			dataForm,
			setIsOpenLoad,
			setMessage,
			handleNotify
		);

		if (isSuccess && logoSaved) {
			setListLogos((list) => [...list, { ...logoSaved }]);
			resetStatesComp();
		} else {
			handleNotify('Erro ao salvar logo, tente novamente', 'error');
		}
	}

	async function editLogo() {
		const canSave = verifyIfCanSave();

		if (!canSave && listLogos.length === 0) {
			handleNotify('Algum erro aconteceu', 'error');
			return;
		}

		if (logoToEdit) {
			const { isSuccess } = await editLogoReq(
				logoToEdit,
				dataForm,
				setIsOpenLoad,
				setMessage,
				handleNotify
			);

			if (isSuccess) {
				const newList = listLogos.map((item) => {
					if (item.id === logoToEdit?.id) {
						return { ...dataForm };
					} else {
						return item;
					}
				});

				setListLogos(newList);
				resetStatesComp();
			}
		}
	}

	useEffect(() => {
		return () => {
			resetStatesComp();
		};
	}, []);

	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				setIsOpenForm((value) => !value);
				resetStatesComp();
			}}
			title={'Formulário logo'}
			buttonClose={false}
		>
			<S.container>
				<S.contentForm>
					<SimpleInput
						label="Nome"
						initialValue={dataForm.name}
						getValue={(value: string) => {
							setDataForm((obj) => ({ ...obj, name: value }));
						}}
					/>

					<InputImgBigger
						idImagem="logoImg"
						initialImage={dataForm.urlLogo}
						getImage={(value: ImgSavedProps) => {
							setDataForm((obj) => ({
								...obj,
								urlLogo: value?.url || ''
							}));
						}}
						label="Logo"
					/>
				</S.contentForm>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							resetStatesComp();
						}}
					>
						Cancelar
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={async () => {
							if (logoToEdit) {
								await editLogo();
							} else {
								await saveLogo();
							}
						}}
					>
						Salvar
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
